module.exports = __webpack_public_path__ + "img/Programbg.c8a79020.png";